import { hash } from "./utils/hash";

// prettier-ignore
// export const quotes = [
//   ["ژیان کورتە، هونەر درێژە.", "Sherko Bekas", "mk4wc7"],
//   ["ئەگەر لەبیرت کردم، لە خۆت مەپرسە بۆچی؟", "Sherko Bekas", null],
//   ["گەر تۆ نەبی، من کێم؟", "Mawlana Khalid", null],
//   ["هەموو شتێک لەبیر دەکرێت، جگە لە خۆشەویستی.", "Nali", null],
//   ["ڕاستگۆیی باشترین سیاسەتە.", "Kurdish Proverb", null],
//   ["زمانی زار، کلیل و قوفڵی دلالە.", "Kurdish Proverb", null],
//   ["ئازادی بێ نرخ نییە.", "Kurdish Proverb", null],
//   ["خۆشەویستی وەک ئاگر وایە، یان گەرمت دەکاتەوە یان دەتسوتێنێت.", "Kurdish Proverb", null],
//   ["بەردێک لە جێی خۆی، باشتر لە هەزار ئەستێرەیە لە ئاسمان.", "Kurdish Proverb", null],
//   ["کوردستان، گۆڕستانی ئیمپراتۆرییەکان.", "Ahmadi Khani", null],
//   ["مرۆڤ بەهۆی زمانەوە مرۆڤە.", "Kaifi", null],
//   ["هەر کەسێک بۆ خاکی خۆی بجەنگێت، شەهیدە.", "Mustafa Barzani", null],
//   ["ژیان شەڕە.", "Kurdish Proverb", null],
//   ["کارێک بکە کە کەس نەیتوانیوە بیکات.", "Masoud Barzani", null],
//   ["هەموو مرۆڤێک دەمرێت، بەڵام هەموو مرۆڤێک ناژی.", "William Wallace", null],
//   ["ئەوەی دەیەوێت هەنگوینی بخوات، با لە هەنگەکان نەترسێت.", "Kurdish Proverb", null],
//   ["بەردەوام بیت، سەرکەوتن هی تۆیە.", "Kurdish Proverb", null],
//   ["خۆشەویستی ڕێگایەکە بۆ بەهەشت.", "Jalal al-Din Rumi", null], // or "Mawlana Rumi"
//   ["ڕۆژێک دێت، هەموو شتێک لەبیر دەکرێت.", "Kurdish Proverb", null],
//   ["ئەگەر بمری لە پێناوی نیشتیمان، شەهیدیت.", "Kurdish Proverb", null],
// ];
export const quotes = [
  { id: '1', text: "ژیان کورتە، هونەر درێژە.", name: "Sherko Bekas", context: "mk4wc7"},
  { id: '2', text: "ئەگەر لەبیرت کردم، لە خۆت مەپرسە بۆچی؟", name: "Sherko Bekas", context: null },
  { id: '3', text: "گەر تۆ نەبی، من کێم؟", name: "Mawlana Khalid", context: null },
  { id: '4', text: "هەموو شتێک لەبیر دەکرێت، جگە لە خۆشەویستی.", name: "Nali", context: null },
  { id: '5', text: "پێش کوشتنم من جووتیار بووم زەویی ڕەقم ئەکرد بە ئاو بازووم ئەستوور، هەرزەکار بووم تا ئێوارە زەردەهەتاو تا تاریکی جووتم ئەکرد هەتا ژیان بەپیتتر کەم تا برسێتیی قاتوقڕ کەم! نەمرێ ئینسان تاکوو «ئاشنان» دڵخۆشتر کەم ئارەقی ڕەنج، توانای شان تێکەڵ بە زەویی وشک بوو بێ پشوودان هەتا زەمینم سەوز کرد تۆو بوو بە نان گوێتان لێیە", name: "Sherko Bekas", context: null },

];


// No need to generate IDs here anymore


export const authors: { [name: string]: string[] } = {
  "Sherko Bekas": ["Poet", "1940-2013"],
  "Mawlana Khalid": ["Mawlana", "1779-1827"],
  "Nali": ["Poet", "1800-1855"],
  "Kurdish Proverb": ["Proverb", ""],
  "Ahmadi Khani": ["Writer and Poet", "1650-1707"],
  "Kaifi": ["Poet", "1920-1999"],
  "Mustafa Barzani": ["Political Leader", "1903-1979"],
  "Masoud Barzani": ["Political Leader", "1946-"],
  "William Wallace": ["Warrior", "1270-1305"],
  "Jalal al-Din Rumi": ["Poet and Mystic", "1207-1273"],
};

export const quotesWithId = quotes.map((quote) => ({
  ...quote, // Spread the existing quote properties
  occupation: quote.name && authors[quote.name] ? authors[quote.name][0] : null,
  time: quote.name && authors[quote.name] ? authors[quote.name][1] : null,
}));

// // Generate unique IDs for each quote
// export const quotesWithId = quotes.map(([text, name, context]) => ({
//   id: hash(text),
//   hash: hash(text),
//   text: text as string, // Ensure text is a string
//   context,
//   name: name as string, // Ensure name is a string
//   occupation: name && authors[name] ? authors[name][0] : null,
//   time: name && authors[name] ? authors[name][1] : null,
// }));